import ROUTE from './route'
import RewardSystemHomeContainer from './containers/reward-system-home-container'

export default [
  {
    name: 'RewardSystemHome',
    path: ROUTE.reward_system_home,
    component: RewardSystemHomeContainer,
    exact: true,
    protect: true
  }
]